import _ from 'lodash';

export const PRICING_FACTOR_PREFIX = 'pricing_factors';
export const CALCULATOR_PREFIX = 'calculator';
export const CALCULATORS_PREFIX = 'calculators';
export const SUB_CATEGORY_PREFIX = 'sub_category';
export const CALCULATORS_KEY = `${PRICING_FACTOR_PREFIX}.${CALCULATORS_PREFIX}`;

export const getAttributeKeys = (name, subCategoryId, attributes) => {
    const calculatorKey = getCalculatorKey(name);
    const pricingFactorsKey = getPricingFactorKey(name);
    const subCategoryKey = getSubCategoryKey(subCategoryId);
    const basePaths = [calculatorKey, pricingFactorsKey];

    return _.flatMap(basePaths, (basePath) =>
        _.flatMap(attributes, (attribute) => [
            `${basePath}.${subCategoryKey}.${attribute}`,
            `${basePath}.${attribute}`
        ])
    );
};

const getCalculatorKey = (name) => `${CALCULATORS_KEY}.${name}_${CALCULATOR_PREFIX}`;

const getPricingFactorKey = (name) => `${PRICING_FACTOR_PREFIX}.${name}`;

export const getSubCategoryKey = (subCategoryId) => `${SUB_CATEGORY_PREFIX}_${subCategoryId}`;
